export default {
  loading: true,
  allEmployees: {},
  singleEmployee: {},
  singleEmployeeCharts: {},
  singleEmployeeResults: {},
  singleEmployeeAllTransactions: {},
  singleEmployeeTransactionsBalance: {}
}
